<template>
  <div class="page-report">
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">INVENTORY</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 inventory-page">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <h2>Receive Stock</h2>
            </div>
            <FormSearch
              :openAddItemModal="createStockTransfer"
              :isStockTransfer="true"
              :total="total"
              :total_low_on_stock="total_in_transit"
              :total_exceeded_high_stock="total_completed"
              @export="exportFile"
              :get-list="getList"
            />
            <div
              class="row mt-4"
              style="min-height: 1120px"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="p-0 custom-table">
                      <table
                        class="table align-items-center mb-0 dataTable"
                        ref="dataTable"
                      >
                        <thead>
                          <tr>
                            <!-- <th class="text-center font-weight-bolder"></th> -->
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder position-relative"
                              >
                                <div
                                  class="pt-3"
                                  style="position: unset"
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      index,
                                      item.field
                                    )
                                  "
                                >
                                  {{ item.label }}
                                </div>
                              </th>
                            </template>
                            <th class="text-center font-weight-bolder">Action</th>
                          </tr>
                          <tr>
                            <!-- <th class="text-center font-weight-bolder"></th> -->
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th class="text-center font-weight-bolder">
                                <input
                                  v-model="columnSearch[index]"
                                  @input="searchColumn(index)"
                                />
                              </th>
                            </template>
                            <th class="text-center font-weight-bolder"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(value, key) in stockTransfers" :key="key">
                            <!-- <td class="text-center text-xss w-5">
                              <div
                                class="d-flex align-items-center justify-content-center"
                              >
                                <i
                                  class="fa fa-ellipsis-v text-secondary cursor-pointer dropdownMenuButton"
                                  aria-hidden="true"
                                  id="dropdownMenuButton"
                                  data-bs-toggle="dropdown"
                                  style="font-size: 16px"
                                ></i>
                                <ul
                                  class="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton"
                                >
                                  <li>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click.prevent="
                                        editStockTransfer(value.id)
                                      "
                                    >
                                      <i class="material-icons me-1">edit</i>
                                      <span>Edit</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td> -->
                            <td class="text-left text-xss">
                              {{ value?.doc_no }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.from }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.to }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.transfer_date }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.completed_date }}
                            </td>
                            <td
                              class="text-left text-xss font-weight-bold"
                              :style="{ color: value?.status_color ?? '#000' }"
                            >
                              {{ value?.status_label }}
                            </td>
                            <td class="text-center text-xss">
                              <div class="d-flex justify-content-center">
                                <div
                                  @click="viewStockTransferDetail(value)"
                                  class="tag-a-custom me-3"
                                >
                                  View
                                </div>
                                <div
                                  class="tag-a-custom"
                                  @click="confirmReceiveStock(value)"
                                >
                                  Receive
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
      <ModalItemList
        :keyReload="keyReloadStockTransferDetail"
        :stockTransferDetail="stockTransferDetail"
      />
      <ModalConfirm
        message="Confirm to add stock to receiving branch?"
        :process-yes="receiveStock"
      />
    </div>
    <form
      :action="`${actionDownload}/merchant/inventory/stock-transfer/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="status" :value="status" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import InventoryService from "../../services/inventory.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import FormSearch from "./components/FormSearch.vue";
import "datatables.net";
import Pagination from "@/components/Pagination.vue";
import { STATUS_COMPLETED, STATUS_IN_TRANSIT } from "./mock_data";
import ModalItemList from "./components/ModalItemList.vue";
import ModalConfirm from '@/components/ModalConfirm.vue'

export default {
  name: "inventory-stock-transfer",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    Pagination,
    ModalItemList,
    ModalConfirm
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: this.$route.params.merchant_id,
      message: "",
      snackbar: null,
      loaderActive: false,
      stockTransfers: null,
      form: {
        physical_branch_id: -1,
        branch_id: -1,
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
      },
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      action_export: "csv",
      dataTable: null,
      columnSearch: [],
      pagination: {},
      page: 1,
      status: null,
      timeType: null,
      total: 0,
      total_completed: 0,
      total_in_transit: 0,
      stockTransferDetail: null,
      keyReloadStockTransferDetail: "keyReloadStockTransferDetail",
    };
  },
  computed: {
    headersData() {
      return [
        {
          label: "Doc No",
          // field: "doc_no",
          hasSortBy: false,
        },
        {
          label: "From",
          // field: "source_name",
          hasSortBy: false,
        },
        {
          label: "To",
          // field: "physical_branch_id",
          hasSortBy: false,
        },
        {
          label: "Transfer At",
          field: "transfer_date_sort",
          hasSortBy: true,
        },
        {
          label: "Completed Date",
          field: "completed_date_sort",
          hasSortBy: true,
        },
        {
          label: "Status",
          // field: "status",
          hasSortBy: false,
        }
      ];
    },
  },
  mounted() {
    this.getList(this.page);
  },
  methods: {
    exportFile(type = "csv") {
      this.action_export = type;
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    initializeDataTable() {
      if (this.dataTable) {
        this.dataTable.destroy();
        this.dataTable = null;
      }

      this.dataTable = $(this.$refs.dataTable).DataTable({
        paging: false,
        searching: true,
        ordering: false,
        info: false,
      });
    },

    searchColumn(index) {
      this.dataTable.column(index).search(this.columnSearch[index]).draw();
    },

    handleChangeSortColumn(idx, field) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      const direction = this.ESortDirectionSelect.direction;

      this.stockTransfers.sort(function (item, item2) {
        if (direction == "asc") {
          if (item[field] > item2[field]) return 1;
          if (item[field] < item2[field]) return -1;
        }

        if (direction == "desc") {
          if (item[field] < item2[field]) return 1;
          if (item[field] > item2[field]) return -1;
        }

        return 0;
      });
    },

    getList(page, status = null, timeType = null) {
      this.isLoadDone = false;
      this.isLoadDoneDataTable = false;
      this.showLoader();
      var dataForm = {
        merchantId: this.$route.params.merchant_id,
        physical_branch_id: this.$route.params.branch_id,
        page: page,
      };

      if ([0, 1, 2, 3].includes(timeType)) {
        dataForm.time_type = timeType;
        this.timeType = timeType;
      } else {
        this.timeType = null;
      }

      if ([STATUS_COMPLETED, STATUS_IN_TRANSIT].includes(status)) {
        this.status = status;
        dataForm.status = status;
      } else {
        this.status = null;
      }

      InventoryService.getStockTransfer(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.stockTransfers = data.data.items;
            this.pagination = data.data;
            this.page = this.pagination.current_page;

            this.total = data.total;
            this.total_completed = data.total_completed;
            this.total_in_transit = data.total_in_transit;

            this.isLoadDone = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    viewStockTransferDetail(value) {
      this.stockTransferDetail = value;
      this.keyReloadStockTransferDetail = Math.random().toString();
      $(".btn-show-stock-transfer-detail-modal").click();
    },

    confirmReceiveStock(value) {
      this.stockTransferDetail = value;
      $(".btn-confirm-modal").click();
    },

    receiveStock() {
      $(".btn-close-modal").click();
      this.showLoader();

      var dataForm = {
        merchantId: this.$route.params.merchant_id,
        physical_branch_id: this.$route.params.branch_id,
        stock_transfer_id: this.stockTransferDetail.id,
      };

      InventoryService.receiveStockTransfer(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Stock transfer received successful";
            this.setTimeOutNotification();
            this.getList(this.page);
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    createStockTransfer() {
      this.$router.push({ name: "StockTransfer" });
    },

    editStockTransfer(id) {
      this.$router.push({ name: "StockTransfer", params: { id: id } });
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
  watch: {
    isLoadDone(val) {
      if (val) {
        setTimeout(() => {
          this.initializeDataTable();
          this.isLoadDoneDataTable = true;
        }, 100);
      }
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

table thead th > span {
  position: relative;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

.dropdownMenuButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 30px;
}

.dropdown-item {
  display: flex;
  align-items: center;
}

.dt-search {
  display: none;
}
</style>
